const allPromos = [
    {
        sportkey: "golf_off",
        code: "ANALYZER26",
        expires: "2026-04-16",
        name: "US Masters Special",
        description: "Try free for 30 days, then just $9.99/year.",
        normalPrice: "$29.99/year"
    },
    {
        sportkey: "global_off",
        code: "ANALYZER26",
        expires: "2026-04-16",
        name: "US Masters Special",
        description: "Try free for 30 days, then just $9.99/year.",
        normalPrice: "$29.99/year",
        globalTag: "30 days free"
    },
    {
        sportkey: "cricket_off",
        code: "ANALYZER26",
        expires: "2026-04-17",
        name: "US Masters Special",
        description: "Try free for 30 days, then just $9.99/year.",
        normalPrice: "$29.99/year",
        globalTag: "30 days free"
    }
]

const getPromo = (key) => {
    const promo = allPromos.find(p => p.sportkey === key);

    if(promo && new Date(promo.expires) > new Date())
    {
        return promo;
    }

    return null;
}


export {getPromo}